import React from "react";
import TextAnimH1 from "../components/TextAnimH1";
import TextAnimP1 from "../components/TextAnimP1";
import CountingAnimation from "../components/CountingAnimation";
import Lottie from "lottie-react";
import projectIcon from "../animation/project-comp.json"
import dateIcon from "../animation/years.json"
import teamIcon from "../animation/team.json"

const AboutStatSection = () => {
  const statsData = [
    {
      number: "15",
      symbol: "k",
      label: "Projects Completed",
      icon: projectIcon
    },
    {
      number: "1200",
      symbol: "+",
      label: "Global Team Members",
      icon: teamIcon
    },
    {
      number: "16",
      symbol: "+",
      label: "Years In Business",
      icon: dateIcon
    },
  ];

  return (
    <div className="dark:text-white py-10 md:py-16 xl:py-20 bg-white pointer-events-none dark:bg-transparent">
      <div className="px-4 md:px-8 xl:px-35 mx-auto flex flex-col justify-center">
        {/* Statistics Row */}
        
        {/* Mobile Layout - Vertical Stack */}
        <div className="flex flex-col gap-8 mb-10 md:hidden">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center items-center mb-4">
                <Lottie
                  animationData={stat.icon}
                  loop={true}
                  autoplay={true}
                  style={{ width: 100 }}
                />
              </div>
              <h2 className="text-6xl font-bold leading-none mb-2">
                <span>{stat.number}</span>
                <span>{stat.symbol}</span>
              </h2>
              <p className="dark:text-zinc-300 text-lg text-center">
                <TextAnimP1>{stat.label}</TextAnimP1>
              </p>
            </div>
          ))}
        </div>

        {/* Tablet Layout - 2x2 Grid with center item */}
        <div className="hidden md:grid xl:hidden grid-cols-2 gap-8 mb-10 place-items-center">
          {statsData.map((stat, index) => (
            <div 
              key={index} 
              className={`text-center ${index === 2 ? 'col-span-2' : ''}`}
            >
              <div className="flex justify-center items-center mb-4">
                <Lottie
                  animationData={stat.icon}
                  loop={true}
                  autoplay={true}
                  style={{ width: 120 }}
                />
              </div>
              <h2 className="text-7xl font-bold leading-none mb-2">
                <span>{stat.number}</span>
                <span>{stat.symbol}</span>
              </h2>
              <p className="dark:text-zinc-300 text-xl text-center">
                <TextAnimP1>{stat.label}</TextAnimP1>
              </p>
            </div>
          ))}
        </div>

        {/* Desktop XL Layout - Original Horizontal */}
        <div className="hidden xl:flex items-center justify-between gap-16 mb-10 px-20">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center md:text-left">
              <div className="flex justify-center items-center">
                <Lottie
                  animationData={stat.icon}
                  loop={true}
                  autoplay={true}
                  style={{ width: 150 }}
                />
              </div>
              <h2 className="text-8xl lg:text-9xl font-bold leading-none mb-1">
                {/* <CountingAnimation> */}
                <span>{stat.number}</span>
                {/* </CountingAnimation>{" "} */}
                <span>{stat.symbol}</span>
              </h2>
              <p className="dark:text-zinc-300 text-xl text-center">
                <TextAnimP1>{stat.label}</TextAnimP1>
              </p>
            </div>
          ))}
        </div>

        {/* Headquarters Section */}
        {/* <div className="mt-12">
          <h1 className="text-8xl lg:text-9xl font-bold leading-none mb-3">
            <TextAnimH1>San Francisco</TextAnimH1>
          </h1>
          <p className="dark:text-zinc-300 text-xl">
            <TextAnimP1>Headquarters</TextAnimP1>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default AboutStatSection;
